import {
    mapState,
    mapActions,
} from 'vuex'
import _ from 'lodash'
import SectionTitle from '@/components/sectionTitle/sectionTitle'
import guideFloating from '@/components/guideFloating/guideFloating'
import DiscountServiceItem from '@/components/discountServiceItem/discountServiceItem'
import DistributionGoodsItem from '@/components/distributionGoodsItem/distributionGoodsItem'
import serviceStoreItem from '@/components/serviceStoreItem/serviceStoreItem'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import viewName from '../constant.js'
import { wxShare } from '@/utils/wxsdk'
import {
    getDistributorMall,
    getDistributorInfo
} from '@/models/distributorMall'

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.distributorMall,
    components: {
        guideFloating,
        swiper,
        swiperSlide,
        SectionTitle,
        DiscountServiceItem,
        DistributionGoodsItem,
        serviceStoreItem,
        // QualityImg
    },
    data () {
        return {
            position:{
                lng: '',
                lat: ''
            },
            name: '', // 分销员名字
            phone: '', // 分销员手机
            distribution_code: '', // 分销员号
            banner: [],
            services: [],
            goods: [],
            store: [],
            distribution_user_type: -1,
            swiperOption: {
                loop: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletActiveClass: 'slide_dot_active',
                    bulletClass: 'slide_dot'
                }
            }
        }
    },
    mounted () {
        const position = sessionStorage.getItem('position')
        if (position) {
            this.position = JSON.parse(position)
        }
        this.$emit('setHeader', {
            title: '商城主页',
            showHeader: true,
            showLeft: true
        })
        this.distribution_code = this.$route.query.distribution_code
        this.showLoading()
        getDistributorInfo({
            distribution_code: this.distribution_code
        }).then((res) => {
            this.hideLoading()
            this.name = res.name
            this.phone = res.phone
            this.distribution_user_type = res.distribution_user_type
            this.configWxShare()
            this.getData()
        })
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        })
    },
    methods: {
        ...mapActions([
            'getLocation',
        ]),
        goServicesList () {
            this.$router.push({
                path: '/discountService',
                query: {
                    distribution_code: this.distribution_code,
                }
            })
        },
        goGoodsList () {
            this.$router.push({
                path: '/distributionList',
                query: {
                    distribution_code: this.distribution_code,
                    distribution_user_type: this.distribution_user_type,
                    fromMall: 1
                }
            })
        },
        onGoToPage2 (item) {
            this.$router.push({
                path: '/distributionDetail',
                query: {
                    distribution_code: this.distribution_code,
                    spec_id: item.spec_id,
                    sstore_id: item.sstore_id,
                    spu_id: item.spu_id,
                    goods_type: item.goods_type,
                    distribution_user_type: this.distribution_user_type
                }
            })
        },
        onGoToPage3 (item) {
            this.$router.push({
                path: '/storeHome',
                query: {
                    distribution_code: this.distribution_code,
                    store_id: item.store_id,
                }
            })
        },
        goRecommendStoreList () {
            this.$router.push({
                path: '/recommendStoreList',
                query: {
                    distribution_code: this.distribution_code
                }
            })
        },
        async getData () {
            this.showLoading()
            let { lat, lng } = this.position
            if (!lat && !lng) {
                await this.getMyLocation().catch((e) => {
                    console.log(e)
                })
            }
            const res = await getDistributorMall({
                distribution_code: this.distribution_code,
                lat: this.position.lat,
                lng: this.position.lng
            })
            this.hideLoading()
            this.banner = res.banner
            this.services = _.chunk(res.services, 3)
            this.goods = res.goods
            this.store = res.store
        },
        getMyLocation () {
            return this.getLocation({ timeout: 3000 }).then(this.getPosition)
        },
        getPosition (position) {
            this.position = position
            sessionStorage.setItem('position', JSON.stringify(this.position))
        },
        configWxShare () {
            if (this.isWeixin) {
                const params = {
                    title: (this.name || this.phone) + '的商城',
                    desc: '更多想不到惊喜优惠在等你，快来看看吧！',
                    imgUrl: 'https://image.carisok.com/images/logo.png',
                    link: location.href
                }
                wxShare(params)
                // wxSharebyData({
                //     // 分享朋友
                //     appMesage: {
                //         title: (this.name || this.phone) + '的商城',
                //         desc: `更多想不到惊喜优惠在等你，快来看看吧！`,
                //         imgUrl: 'https://image.carisok.com/images/logo.png'
                //     },
                //     // 分享朋友圈
                //     timeline: {
                //         title: (this.name || this.phone) + '的商城 #更多想不到惊喜优惠在等你，快来看看吧！',
                //         imgUrl: 'https://image.carisok.com/images/logo.png'
                //     }
                // })
            }
        }
    }
}
